<template>
  <div
    class="fixed flex md:flex-col inset-x-0 bottom-0 md:inset-x-auto md:bottom-auto md:inset-y-1/2 md:right-0 z-50"
  >
    <span
      class="flex justify-center flex-auto p-4 md:w-14 text-white cursor-pointer bg-primary hover:bg-gray-700"
      @click.prevent="twitter"
    >
      <span class="fab fa-twitter text-2xl"></span>
    </span>
    <a
      class="flex justify-center flex-auto p-4 md:w-14 text-white cursor-pointer bg-primary-dark hover:bg-gray-700"
      @click.prevent="linkedin"
    >
      <span class="fab fa-linkedin text-2xl"></span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'ShareButtons',
  computed: {
    currentUrl() {
      return location.href;
    },
    currentTitle() {
      return document.title;
    },
  },
  methods: {
    twitter() {
      const url =
        'https://twitter.com/intent/tweet?url=' +
        this.currentUrl +
        '&text=' +
        this.currentTitle;
      window.open(url, 'Twitter Window', 'width=600,height=300');
    },
    linkedin() {
      const url =
        'https://www.linkedin.com/sharing/share-offsite/?url=' +
        this.currentUrl +
        '?title=' +
        this.currentTitle;
      window.open(url, 'LinkedIn Window', 'width=600,height=400');
    },
  },
};
</script>
